import { collection, addDoc, query, where, getDocs, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "./firebase"
import { name, patient_path } from "./login"



//__________________PATIENTS FUNCTIONS (CRUD OPERATIONS)____________________
/**
 * Returns the registration array of a patient.
 * @param {object} id - Patient ID number
 * @returns {Array} - Array with all the appointment information of a patient contained in objects
 */
 export function getPatient(id) {
    return new Promise(async (resolve, reject) => {
        console.log('getPatient(): path', patient_path, id);
        // listing all the documents in a given path where the cr number is equals to id
        const q = query(collection(db, patient_path), where("cr", "==", id));
        // getting the documents specified in q.
        const querySnapshot = await getDocs(q);
        // creating empty list to append the objects with the appointments for that id number
        let patientList = [];
        console.log('getPatient(): querysnapshot:', querySnapshot)

        querySnapshot.forEach((doc) => {
            //Pushing the data to patientList for all objects returned in querySnapshot
            patientList.push(doc.data())
        });
        // Resolving premise, since getPatient(id) is an async function
        console.log('getPatient() resolving:', patientList)
        // find patient record in list
        let patient = patientList.filter(p => p.hasOwnProperty('dateOfBirth'))[0];
        resolve(patient);
    })
}



/**
 * Adds a new patient to Firebase
 * @param {object} patient - Object containing all the properties of the patient
 * @returns {Boolean} whether patient will be created or not
 */
export async function createPatient(patient) {
    // Checking if we're registering a new patient
    const doesPatientExist = await getPatient(patient.cr); // updated to handle getPatient returning Obj not list
    if (!doesPatientExist) {

        const physiciansRef = collection(db, patient_path);
        // Adding document with the following properties to the user/physician collection
        const newPatient = await addDoc(physiciansRef, {
            cr: String(patient.cr),
            dateOfBirth: patient.dateOfBirth,
            registrationTime: (new Date).getTime(),
            name: patient.name,
            diseases: patient.diseases, // array of objects
            uniquePatientId: "",
        })
        // Update the document with the Firebase-generated ID as uniquePatientID
        await updateDoc(newPatient, {
            uniquePatientId: newPatient.id
        });
        return newPatient.id;
    }
    else {
        alert(`Patient ${patient.name} is already registered`)
        return null;
    }
}



/**
 * Updates the details of an existing patient in the database.
 * 
 * This function queries the database for a patient with a specific uniquePatientID.
 * If exactly one matching document is found, the patient's details are updated.
 * If no matching document is found or multiple documents are found, an error is logged.
 * 
 * @param {object} patient - An object containing the updated details of the patient.
 *                         - Should include the uniquePatientID for identifying the patient.
 * @returns {Promise<void>} A promise that resolves when the update operation is complete.
 *                          Does not return a value but logs an error if the operation fails
 *                          or if the uniquePatientID matches multiple or no patients.
 */
export async function editPatient(patient) {
    try{
        // querying all documents matching our random generated appointment id
        const q = query(collection(db, patient_path), where('uniquePatientId', '==', patient.uniquePatientId));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.size != 1) {
            console.log('Error! Multiple patients found with the same id');
            return;
        }
        const snap = querySnapshot.docs[0];
        const snapId = snap.ref.id;
        const docRef = doc(db, patient_path, snapId);
    
        updateDoc(docRef, patient)
            .then((docRef) => {
                console.log('Patient modified successfully!')
            }).catch((error) => { 
                console.log(error)});
        return true;
    }
    catch (error){
        console.log(`Error updating patient, code: ${JSON.stringify(error)}.`)
        return false;
    }
}